import {
  Dialog,
  DialogContent,
  DialogTitle,
  Table,
  TableBody,
  TableHead,
  TableCell,
  TableRow,
} from "@material-ui/core";
import "moment/locale/es";
import React from "react";

export const ModalMultiSesion = (props) => {
  return (
    <Dialog
      fullWidth
      maxWidth="lg"
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title" style={{ paddingBottom: "0px" }}>
        Sesiones
      </DialogTitle>
      <DialogContent>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell style={{ width: "15%" }}>Fecha</TableCell>
              <TableCell style={{ width: "70%" }}>Descripción</TableCell>
              <TableCell style={{ width: "15%" }}>Sesiones</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {[].map((practica, index) => {
              return (
                <TableRow key={index} practica={`practica-${index}`}>
                  <TableCell>
                    {/* {new Date(
                      practica.fechaInicioVigencia
                    ).toLocaleDateString()} */}
                  </TableCell>
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </DialogContent>
    </Dialog>
  );
};
